interface ChatBubbleProps {
  onClick: () => void;
  isOpen: boolean;
  hasBeenOpened: boolean;
}

export const ChatBubble = ({ onClick, isOpen, hasBeenOpened }: ChatBubbleProps) => {
  if (isOpen) return null;

  return (
    <>
      <button
        onClick={onClick}
        className="fixed z-[90] rounded-full transition-transform duration-200 hover:scale-110"
        style={{
          bottom: "24px",
          right: "24px",
          width: "56px",
          height: "56px",
          background: "linear-gradient(135deg, #0891b2, #06b6d4)",
          boxShadow: "0 4px 20px rgba(6,182,212,0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        aria-label="Open chat"
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>

        {!hasBeenOpened && (
          <span
            className="chat-badge-pulse"
            style={{
              position: "absolute",
              top: "-2px",
              right: "-2px",
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              background: "#ffffff",
              color: "#0a0a0a",
              fontSize: "11px",
              fontWeight: 700,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              lineHeight: 1,
              boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
            }}
          >
            1
          </span>
        )}
      </button>

      <style>{`
        .chat-badge-pulse {
          animation: badgePulse 2s ease-in-out infinite;
          will-change: transform, opacity;
        }
        @keyframes badgePulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.15); opacity: 0.85; }
        }
      `}</style>
    </>
  );
};
